import {
    CELLPHONE_RECOVERY_STORE_NAMESPACE as STORE_NAMESPACE_CELLPHONE_RECOVERY,
    MUTATION_UPDATE_CELLPHONE_RECOVERY_SETTINGS as MUTATION_UPDATE_STATE_CELLPHONE_RECOVERY,
} from 'cellphone_recovery/store';

export const CELLPHONE_RECOVERY_OPERATIONS = {
    cellphoneRecovery: 'cellphone_recovery',
};

export const CELLPHONE_RECOVERY_OPERATIONS_MUTATION_UPDATE_STATE = {
    cellphone_recovery: `${STORE_NAMESPACE_CELLPHONE_RECOVERY}/${MUTATION_UPDATE_STATE_CELLPHONE_RECOVERY}`,
};
